import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import { route } from '@helpers'
import { Box } from '@styles/helpers'
import { mTablet, tablet } from '@styles/mixins'
import { colors } from '@styles/vars'
import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

const CurrentSalon = ({ data }: ArchiveComponentProps<Resources.CurrentSalon>) => {
    const { id, name, slug, background_url } = data
    return (
        <Box narrow={true}>
            <Wrapper>
                <Grid gap="20px">
                    <a target="_blank" href={route("general:salon", slug)}><Image src={background_url} /></a>
                    <a target="_blank" href={route("general:salon", slug)}><h2>{name}</h2></a>
                    <Grid gap="10px">
                        <Button to={route("customer:salon", id)}>Participate</Button>
                        <ActionDescription>By participating, you acknowledge you've agreed to <a href={route("general:salon:conditions", slug)} target="_blank">conditions</a>.</ActionDescription>
                    </Grid>
                </Grid>
            </Wrapper>
        </Box>
    )
}

export default React.memo(CurrentSalon)

/* STYLES */
const Wrapper = styled.div`
    a {
        text-decoration: none;
    }
`

const ActionDescription = styled.small`
    text-align: center;
    color: ${colors.darkGrey};
    a {
        text-decoration: underline;
    }
    ${tablet(css`
        max-width: 220px;
        margin: 0 auto;
    `)}
`

const Content = styled.div`
    & > a {
        display: block;
        margin-bottom: 15px;
    }
`

const Image = styled.div<{ src: string }>`
    height: 200px;
    width: 100%;
    background: ${props => props.src ? "url(" + props.src + ") center center no-repeat" : colors.greyBackground};
    background-size: cover;
    border-radius: 10px;
`